import axios from "axios";

const API_URL = "https://api.cu.kacc.mn/api";
// const API_URL = "http://192.168.0.198:8000/api";

export const fetchData = async (endpoint) => {
  const response = await axios.get(`${API_URL}/${endpoint}/`);
  return response.data;
};

export const postData = async (endpoint, data) => {
  const response = await axios.post(`${API_URL}/${endpoint}/`, data);
  return response.data;
};

export const updateData = async (endpoint, id, data) => {
  try {
    delete data.product_details;
    delete data.fixed_user;
    delete data.totalPrice;
    delete data.createdDate;
    delete data.creted_user;

    const response = await fetch(`${API_URL}${endpoint}/${id}/`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Update failed:", error.message);
    throw error;
  }
};

export const updateStatus = async (endpoint, data) => {
  console.log(data);
  try {
    const response = await fetch(`${API_URL}${endpoint}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: data,
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error("Update failed:", error.message);
    throw error;
  }
};

export const deleteData = async (endpoint, id) => {
  const response = await axios.delete(`${API_URL}/${endpoint}/${id}/`);
  return response.data;
};
